import { ENTITY_DEPARTMENT, ENTITY_USER } from 'constants/schemas';
import { useDepartment, useDepartmentHasLoaded, useMyGlobalPermission, useUpdateEntity } from 'hooks/store.hooks';

import { ACTION_VIEW } from 'constants/permission.constants';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import UserTable from 'components/UserTable';
import { useEntityIsReadOnly } from 'hooks/Entity.hooks';

function DepartmentUsers(props) {
  const { id } = props;
  const update = useUpdateEntity();
  const isReadOnly = useEntityIsReadOnly();
  const userIds = useDepartment(id, 'users');
  const usersHasLoaded = useDepartmentHasLoaded(id, 'users');
  const canViewUser = useMyGlobalPermission(ENTITY_USER, ACTION_VIEW);

  const onAssign = (selection) => {
    update({ type: ENTITY_DEPARTMENT, id, key: 'users', value: selection });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography>Members</Typography>
      <UserTable
        userIds={userIds ?? []}
        loading={!usersHasLoaded}
        onAssign={!isReadOnly && canViewUser ? onAssign : null}
        initAssignment={userIds ?? []}
        sx={{
          border: 1,
          borderColor: 'divider',
          borderRadius: 2,
        }}
      />
    </Box>
  );
}

DepartmentUsers.propTypes = {
  id: PropTypes.number.isRequired,
};

export default DepartmentUsers;
